import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import {
    fetchAccessSessionActivitiesSuccess,
    fetchAccessSessionActivitiesFailure,
} from '../actions/reservations/session/reservationSessionActivities';
import * as types from '../actions/types';

function* fetchReservationAccessSessionActivitiesAsync({ payload }) {
    const url = `${ config.getApiBaseUrl() }/reservations/${ payload }/sessions`;

    try {
        const response = yield apiClient.read(url);

        yield put(fetchAccessSessionActivitiesSuccess({
            id: payload,
            response: response,
        }));
    } catch (error) {
        yield put(fetchAccessSessionActivitiesFailure(error));
    }
}

function* failureMessage({ error }) {
    const { message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));
}

export default function* reservationAccessSessionActivitiesSagas() {
    yield [
        takeEvery(types.FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES, fetchReservationAccessSessionActivitiesAsync),
        takeEvery(types.FETCH_RESERVATION_ACCESS_SESSION_ACTIVITIES_FAILURE, failureMessage),
    ];
}


// WEBPACK FOOTER //
// ./src/store/sagas/reservationAccessSessionActivitiesSagas.js